module.exports = __webpack_public_path__ + "img/2.aaea5273.png";